import cn from 'classnames';

import moreBannerImage from '../../../assets/images/more_banner_photo.png';
import rightArrowIcon from '../../../assets/icons/arrowRight.svg';

import styles from './styles.module.css';

interface IMoreBannerProps {
    className?: string;
}

// TODO: пошаманить еще с перелинковкой

export const MoreBanner: React.FC<IMoreBannerProps> = ({className}) => {
    return (
        <div className={cn(styles.container, className)}>
            <div className={styles.leftContainer}>
                <div className={styles.title}>
                    Welcome to the Art Institute of Chicago,
                </div>
                <div className={styles.text}>
                    home to a collection of art that spans centuries and the globe—and one of Tripadvisor’s “Best of the Best” US attractions of 2023. On this website you can find thousands of artworks
                </div>
                <a className={styles.buttonContainer} href="/">
                    <span>More about</span>
                    <img src={rightArrowIcon} alt="See more"/>
                </a>
            </div>
            <img className={styles.rightContainer} src={moreBannerImage} alt="View of the hall"/>
        </div>
    )
}